<template>
  <div class="page-box">
    <div class="page-content">
      <div class="list-box">
        <div class="banner-title-box">
          <div class="banner-title">候补预约信息</div>
        </div>
        <div class="list-main" style="padding: 0 10px">
          <van-form ref="formData" @submit="onSubmit">
            <van-field
              v-model="informationTotal.subscribe"
              readonly
              placeholder="预约"
              :rules="[{ required: true, message: '请填写预约' }]"
            >
              <template #left-icon>
                <van-image class="size-icon" src="/static/images/info.png" />
              </template>
            </van-field>

            <van-field
              left-icon="smile-o"
              v-model="informationTotal.name"
              :rules="[{ required: true, message: '请填写人员' }]"
              placeholder="人员"
            >
              <template #left-icon>
                <van-image class="size-icon" src="/static/images/people.png" />
              </template>
            </van-field>
            <!--<van-field
              left-icon="smile-o"
              v-model="informationTotal.company"
              :rules="[{ required: true, message: '请填写正确部门' }]"
              placeholder="部门"
            >
              <template #left-icon>
                <van-image
                  class="size-icon"
                  src="/static/images/department.png"
                />
              </template>
            </van-field>-->
            <van-field
              left-icon="smile-o"
              name="pattern"
              v-model="informationTotal.phone"
              :rules="[{ pattern, message: '请填写正确手机号' }]"
              maxlength="11"
              placeholder="手机号"
            >
              <template #left-icon>
                <van-image class="size-icon" src="/static/images/phone.png" />
              </template>
            </van-field>
            <!--<van-field
              left-icon="smile-o"
              name="isEmail"
              v-model="informationTotal.email"
              :rules="[{ validator, message: '请填写正确邮箱' }]"
              placeholder="邮箱"
            >
              <template #left-icon>
                <van-image class="size-icon" src="/static/images/email.png" />
              </template>
            </van-field>--->
            <van-field
              v-if="facility.isWeixin"
              left-icon="smile-o"
              :rules="[{ required: true, message: '请填写正确编码' }]"
              maxlength="5"
              v-model="informationTotal.gateCard"
              placeholder="门卡背面后5位编码"
            >
              <template #left-icon>
                <van-image class="size-icon" src="/static/images/card.png" />
              </template>
            </van-field>
          </van-form>
        </div>
      </div>

      <div class="list-box" v-if="serviceInfo.servicePosition">
        <div class="banner-title-box">
          <div class="banner-title">地点</div>
        </div>
        <div class="list-main">
          {{ serviceInfo.servicePosition }}
        </div>
      </div>

      <!--服务内容-->
      <div class="list-box">
        <div class="banner-title-box">
          <div class="banner-title">服务内容</div>
        </div>
        <div
          class="list-main"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div
            v-if="
              serviceObj.additionalSpuName &&
              serviceObj.additionalSpuName.length > 0
            "
          >
            {{ serviceInfo.name }}|{{ serviceObj.additionalSpuName.toString() }}
          </div>
          <div v-else>{{ `${serviceInfo.name} | ${serviceItemName}` }}</div>
          <div class="item-price">
            <span class="unit1">¥</span
            >{{ servicePrice === 0 ? "免费" : servicePrice
            }}<span class="unit2">/{{ unit }}</span>
          </div>
        </div>
      </div>

      <div class="list-box">
        <div class="banner-title-box">
          <div class="banner-title">取消预订规则</div>
        </div>
        <div class="list-main">
          服务开始前可以免费取消这次预约，服务开始后15分钟未到场，将自动取消这次预约。
        </div>
      </div>

      <div class="list-box appointment-box">
        <div class="item-price">
          <span class="desc">费用</span>
          <span class="unit1">¥</span>
          {{ servicePrice === 0 ? "免费" : servicePrice }}
          <span class="unit2">/{{ unit }}</span>
        </div>
        <div class="appointment-btn" @click="handleAtOnce">立即预约</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  makeAnAppointmentSubmit,
  commoditySpuDetail,
  beAnAlternate,
} from "@/api/index/index";
import utils from "@/common/js/utils";
export default {
  name: "candidateInfo",
  data() {
    return {
      facility: {},
      serviceItemName: "",
      servicePrice: "",
      unit: "",
      additionalSpuName: [],
      informationTotal: {
        subscribe: "",
        name: "",
        company: "",
        phone: "",
        email: "",
        gateCard: "",
      },
      pattern: /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/,
      serviceObj: {}, // sessionStorage数据
      serviceInfo: {}, // 接口地址
    };
  },
  created() {
    this.facility = utils.BrowserInfo();
    if (Object.keys(this.$store.state.userInfo).length > 0) {
      this.informationTotal.name = this.$store.state.userInfo.nickname;
      this.informationTotal.phone = this.$store.state.userInfo.phone;
    }
  },
  mounted() {
    if (sessionStorage.getItem("candidate") !== null) {
      this.serviceObj = JSON.parse(sessionStorage.getItem("candidate"));
      this.informationTotal.subscribe = `${this.serviceObj.presentDate}的${this.serviceObj.name}服务`;
      this.additionalSpuName = this.serviceObj.additionalSpuName
        ? this.serviceObj.additionalSpuName
        : [];
      this.servicePrice = this.serviceObj.price;
      this.unit = this.serviceObj.unit;
      this.serviceItemName = this.serviceObj.name;
      this.getCommoditySpuInfo(this.serviceObj.shopId);
    }
  },
  methods: {
    async getCommoditySpuInfo(shopId) {
      let res = await commoditySpuDetail(shopId);
      this.serviceInfo = res.data;
    },
    validator(value) {
      return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/g.test(
        value
      );
    },
    requestObj() {
      return {
        merchanId: this.serviceInfo.merchanId, // 360id
        skuId: this.serviceObj.shopId, // 最外层的id
        shopId: this.serviceObj.merchantId, //服务id
        shopName: this.serviceInfo.name, // 服务名字
        serviceItemList: this.serviceObj.selectTimeData, // 标签、候补value
        presentDate: this.serviceObj.presentDate, // 当前时间
        orderAmount: this.serviceObj.price, // 价格
        personnelCreateSdkParam: this.informationTotal, // 基本信息
        serviceName: this.serviceObj.name, // 服务项名字
        price: this.serviceObj.price, // 价格
        type: this.facility.isWeixin ? 19 : 18, // ? 类型如何区别
        servicePosition: this.serviceInfo.servicePosition, // 服务项地址
        candidateValue: this.serviceObj.candidateValue,
      };
    },
    async onSubmit() {
      let makeAnAppointmentResult;
      const selectTimeVariate = this.serviceObj.selectTimeData;
      this.additionalSpuName.length > 0
        ? (selectTimeVariate[0].additionalSpuName = this.additionalSpuName.toString())
        : (selectTimeVariate[0].additionalSpuName = [].toString());
      // 候补
      makeAnAppointmentResult = await beAnAlternate(this.requestObj());
      if (makeAnAppointmentResult.success) {
        sessionStorage.removeItem("candidate"); // 清除缓存
        sessionStorage.removeItem('setMakeAnAppointmentTime') // 清除预约信息
        this.$toast(makeAnAppointmentResult.message);
        this.$router.replace({
          path: "/myMakeAnAppointment",
        });
      } else {
        this.$toast(makeAnAppointmentResult.message);
      }
    },
    handleAtOnce() {
      this.$refs.formData.submit();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background: #eeeeee;
  padding: 0 12px 10px;

  .custom-image {
    /deep/ .van-empty__image {
      width: 90px;
      height: 90px;

      img {
        width: 90px;
        height: 90px;
      }
    }
  }
}
.list-box {
  margin-top: 10px;
  border-radius: 5px;
  background: #fff;
  .banner-title-box {
    padding: 15px 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid #d8d8d8;

    .banner-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin-right: 10px;
    }
  }

  .list-main {
    padding: 15px 10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;

    .item-price {
      display: flex;
      align-items: center;
      color: #16aa77;
      font-size: 16px;
      font-family: PingFangSC-Regular;
      font-weight: 600;
      .unit1 {
        font-size: 12px;
        font-family: PingFangSC-Semibold;
      }
      .unit2 {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: normal;
        color: #666666;
      }
    }

    .edit-btn {
      margin-left: 10px;
      width: 60px;
      height: 30px;
      border: 1px solid #999999;
      border-radius: 15px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .van-cell {
      padding: 10px 0;
      align-items: center;

      &:after {
        right: 0px;
        left: 22px;
      }

      /deep/ .van-field__left-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .size-icon {
        width: 50%;
        height: 50%;
        margin-right: 2px;
      }
    }
  }
}

.appointment-box {
  padding: 15px 10px;
  .item-price {
    display: flex;
    align-items: center;
    color: #16aa77;
    font-size: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 600;
    .desc {
      margin-right: 5px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
    }
    .unit1 {
      font-size: 12px;
      font-family: PingFangSC-Semibold;
    }
    .unit2 {
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: normal;
      color: #666666;
    }
  }
  .appointment-text {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #16aa77;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .appointment-btn {
    background: #16aa77;
    border-radius: 20px;
    height: 40px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
  }
}
</style>
